import { render, staticRenderFns } from "./GenerateJeembtn.vue?vue&type=template&id=4f90d735"
import script from "./GenerateJeembtn.vue?vue&type=script&lang=js"
export * from "./GenerateJeembtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports